import script from "./AccidentsPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./AccidentsPolicy.vue?vue&type=script&setup=true&lang=js"

import "./AccidentsPolicy.vue?vue&type=style&index=0&id=1cd87ab3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cd87ab3"]])

export default __exports__